<div class="ctn-left ctn-wrap ctn-sep ctn-bottom">


    <div class="item-sep ctn ctn-left ctn-bottom" *ngFor="let segmentItemKey of bookingItem.segment | keys; let i = index">
        <ng-container *ngFor="let journeyItemKey of bookingItem.segment[segmentItemKey].journey; let j = index;" >

            <ng-container *ngFor="let item of bookingItem.segment[segmentItemKey][selectedJourneys[i]].sector;let k = index; let f=first; let l=last">
                <div  *ngIf="j===0">
                    <strong *ngIf="item.begin && f" class="label critBegin">{{ item.begin | dateMoment:dateFormat.momentMedium }}</strong>
                    <strong [innerHTML]="(item.begin | dateTimeRange)" *ngIf="item.begin && item.begin.min" class="label critBeginMin"></strong>
                    <strong *ngIf="item.from" class="critFromTo">{{ item.from }}</strong>
                    <!-- <span class="label">{{item.begin | dateMoment:dateFormat.time}}</span> -->
                    <strong *ngIf="item.from && item.to" [class.arrow]="!l">
                        <fa-icon [icon]="iconArrowRight"></fa-icon>
                    </strong>
                    <strong *ngIf="(item.to && l)" class="critFromTo">{{ item.to }}</strong>
                    <ng-container *ngIf="!l">

                        <strong *ngIf="(bookingItem.segment[segmentItemKey][selectedJourneys[i]].sector[k+1].from != item.to)" class="critFromTo">{{ item.to }} /&nbsp;</strong>
                    </ng-container>
                    <!-- <span class="label">{{item.end | dateMoment:dateFormat.time}}
                        <ng-container *ngIf="getDayDiff(item.begin, item.end) || getDayDiff(item.begin, item.end) !=0 ">{{getDayDiff(item.begin, item.end)}}</ng-container>
                    </span> -->

                </div>
            </ng-container>
        </ng-container>
    </div>

    <strong [innerHTML]="(bookingItem.value | price: 'EUR')"></strong>
    <span class="label"> {{Yii.t('wui-iqba-js', 'par ADT')}}</span>


</div> <!-- /.ctn-left -->
